(function () {
  class CollectionLoadMore extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector("[data-load-more]");
      this.grid = document.getElementById("CollectionProductGrid");
      this.label = this.querySelector("[data-progress-label]");
      this.fill = this.querySelector("[data-progress-fill]");
      this.total = Number(this.dataset.total || 0);
      if (this.button) {
        this.button.addEventListener("click", this.onClick.bind(this));
      }
    }

    onClick(event) {
      event.preventDefault();
      const nextUrl = this.button.getAttribute("data-next-url");
      if (!nextUrl || this.button.classList.contains("is-loading")) return;
      this.load(nextUrl);
    }

    async load(nextUrl) {
      this.button.classList.add("is-loading");
      try {
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set("section_id", this.dataset.sectionId);
        const response = await fetch(url.toString(), {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const incoming = doc.querySelectorAll("#CollectionProductGrid > *");
        incoming.forEach((node) => this.grid.appendChild(node));
        const nextButton = doc.querySelector("[data-load-more]");
        const shown = this.grid.children.length;
        this.updateProgress(shown);
        if (nextButton && nextButton.getAttribute("data-next-url")) {
          this.button.setAttribute("data-next-url", nextButton.getAttribute("data-next-url"));
          this.button.classList.remove("is-loading");
        } else if (this.button) {
          this.button.remove();
        }
      } catch (error) {
        this.button.classList.remove("is-loading");
      }
    }

    updateProgress(shown) {
      const total = this.total || shown;
      const percent = total ? Math.min(100, (shown / total) * 100) : 100;
      if (this.fill) this.fill.style.width = percent + "%";
      if (this.label) {
        this.label.textContent = "You've viewed " + shown + " of " + total + " results";
      }
    }
  }

  if (!customElements.get("collection-load-more")) {
    customElements.define("collection-load-more", CollectionLoadMore);
  }
})();
